import { useMatchStatusStyles } from '@components/StatsConsole/Widgets/H2HWidget/parts/common/MatchStatus/hooks/useMatchStatusStyles';
import { MatchStatusType } from '@utils/types';

interface IMatchStatusProps {
    status: MatchStatusType | null;
    mb?: string;
    mr?: string;
    isBottomBar?: boolean;
}

const MatchStatus = ({ status, mb = 'mb-[0px]', mr = 'mr-[0px]', isBottomBar = false }: IMatchStatusProps) => {
    const { background, border, text } = useMatchStatusStyles(status);

    const BASE_CLASSES = 'text-[12px] leading-[16px] font-robotoRegular font-normal w-[16px] h-[16px] rounded-[4px] flex justify-center items-center';
    
    const commonClasses = `${BASE_CLASSES} ${text} ${background} ${mb} ${mr}`;

    if (isBottomBar) {
        return (
            <div className="flex flex-col justify-start items-center gap-[2px] pt-[4px] min-w-[16px]">
                <div className={commonClasses}>
                    {status}
                </div>
                <div className={`w-[10px] border-[1px] ${border}`} />
            </div>
        );
    }

    return (
        <div className={`${commonClasses} min-w-[16px]`}>
            {status}
        </div>
    );
};

export default MatchStatus;